export default "__VITE_ASSET__BedsAsCB__"